import { useEffect } from "react";
import { getApiUiUrl } from "@/shared/lib/apiDocsUrl";
import { createMediator, type Mediator } from "@/shared/lib/componentHierarchy";
import {
  getHierarchyResourceSnapshot,
  useComponentNode,
  useHierarchyResource,
} from "@/shared/ui/component-hierarchy/hooks";

type ApiDocsEvent = { type: "root.api-docs-entered" };
export function useApiDocsPresenter(): void {
  const mediator = useHierarchyResource<
    Mediator<boolean, ApiDocsEvent, "redirect">
  >((previous) =>
    createMediator<boolean, ApiDocsEvent, "redirect">(
      previous?.isDisposed
        ? (getHierarchyResourceSnapshot<boolean>(previous) ?? false)
        : false,
      (state) => ({
        status: "handled",
        state: true,
        effects: state ? [] : ["redirect"],
      }),
      { runEffect: () => window.location.replace(getApiUiUrl()) },
    ),
  );
  const node = useComponentNode((event) => {
    if (event.type !== "root.api-docs-entered") return "unhandled";
    mediator.dispatch(event as ApiDocsEvent);
    return "handled";
  });
  useEffect(() => {
    node.dispatch({ type: "root.api-docs-entered" });
  }, [node]);
}
